var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFullChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2109 13.1016C16.4219 13.3359 16.4219 13.6875 16.2109 13.8984L11.7109 18.3984C11.4766 18.6328 11.125 18.6328 10.9141 18.3984C10.6797 18.1875 10.6797 17.8359 10.9141 17.625L15.0156 13.5234L10.9141 9.39844C10.6797 9.1875 10.6797 8.83594 10.9141 8.625C11.125 8.39062 11.4766 8.39062 11.6875 8.625L16.2109 13.1016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullChevronRight);
export default __webpack_public_path__ + "static/media/icon-full-chevron-right.8dae71c9f079fb49770263f1ccf7de13.svg";
export { ForwardRef as ReactComponent };